export const INTERNAL_SERVER_ERROR = 'Error interno del servidor, inténtalo de nuevo más tarde'
export const UNEXPECTED_ERROR = 'Ocurrio un error inesperado, inténtalo de nuevo más tarde'

const VIEW_ERROR_MESSAGES = {
  login: {
    'invalid credentials': 'El correo o la contraseña son inválidas'
  },
  register: {
    'email already exists': 'Ya existe una cuenta con este correo'
  },
  recover_account: {
    'user not found': 'No existe una cuenta con el correo ingresado'
  },
  create_address: {
    'number of addresses exceeded': 'Has superado el número de direcciones que puedes crear, por favor elimina o actualiza alguna de las direcciones creadas'
  },
  shipping_form: {
    'resource not found': 'Lo sentimos, actualmente no se realizan envíos para la ciudad seleccionada.'
  },
  delivery_address: {
    'resource not found': 'Lo sentimos, actualmente no se realizan envíos para la dirección ingresada.'
  },
  search_order: {
    'resource not found': 'Lo sentimos, no se encontró ninguna orden para el código de pedido ingresado.'
  }
}

export function getErrorMessage (view, error) {
  if (!error || !error.message) {
    return UNEXPECTED_ERROR
  }

  const viewMessages = VIEW_ERROR_MESSAGES[view]
  if (!viewMessages) {
    return error.message
  }

  const message = viewMessages[error.message]

  return message || error.message
}
